import React from 'react';
import LogoutButton from '../buttons/LogoutButton';
import { Link } from 'react-router-dom';

class TopBarForum extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className='top-bar'>
                <div>
                    <Link to='/forum'>Back to Forum</Link>
                </div>
                <div>
                    <LogoutButton />
                </div>
            </div>
        );
    }
}

export default TopBarForum;
